var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rename",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24310",
    "data-name": "Path 24310",
    d: "M18.161,22.968H5a2,2,0,0,1-2-2v-10a2,2,0,0,1,2-2H18.1a1,1,0,1,1,0,2H5v10H18.161a1,1,0,0,1,0,2ZM29,10.968v10a2,2,0,0,1-2,2H23V25h.645a1,1,0,0,1,0,2H19.968a1,1,0,1,1,0-2H21c0-2.012,0-15.63,0-18H19.968a1,1,0,1,1,0-2h3.677a1,1,0,0,1,0,2H23V8.968h4a2,2,0,0,1,2,2Zm-2,0H23v10h4Z",
    transform: "translate(-3 -5)",
    fill: "#afabab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.01f2fe79b0f8631c25aaa36cf299666b.svg";
export { ForwardRef as ReactComponent };